import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import { SessionContext } from '../../providers/SessionContextProvider'
import Loading from '../Loading'
import { getGlobalContext, isBrowser } from '../../utils/window'
import AdminHeader from '../AdminHeader'

function PrivateRoute({ component, ...rest }) {
  const { user } = useContext(SessionContext)

  // used in apolloHandler so we can redirect the user to the login screen
  // if he is unauthorized
  getGlobalContext().usesPrivateRoute = true

  if (!isBrowser || !user) return <Loading />
  const { pathname: redirectTo = '/' } = window.location
  return user.role === 'ADMINISTRATOR'
    ? withAdminNav({ component, rest, user })
    : <Redirect to={{ pathname: '/login', state: { redirectTo } }} />
}

function withAdminNav({ component, rest, user }) {
  return (
    <>
      {user.role === 'ADMINISTRATOR' && <AdminHeader />}
      <Route component={component} {...rest} />
    </>
  )
}


withAdminNav.propTypes = {
  component: PropTypes.any.isRequired,
  rest: PropTypes.any.isRequired,
  user: PropTypes.object.isRequired,
}

PrivateRoute.propTypes = {
  component: PropTypes.any.isRequired,
}

export default PrivateRoute
